import {
  Box,
  BoxProps,
  HeaderTooltip,
  ProgressBar,
  Text,
  useHeaderTooltip,
  useStyle,
} from '@bonanza-social/moonlight';
import { memo, useEffect, useRef } from 'react';
import useLoyalty from './hooks/useLoyalty';
import { useTranslation } from '@bonanza-social/i18n';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useViewDimensions } from '@bonanza-social/toolkit/hooks';
import { Pressable } from 'react-native';
import { BottomSheet } from '@bonanza-social/navigation';

const staticStyles: BoxProps = {
  height: 40,
  variant: 'default',
  width: '100%',
  backgroundColor: 'secondaryBackgroundDefault',
  borderRadius: 'radius-200',
  padding: 'space-200',
  gap: 'space-100',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'visible',
  zIndex: 1,
};

function Levels(props: BoxProps) {
  const pressableStyle = useStyle({ ...staticStyles, ...props });
  const [t] = useTranslation('levels');
  const { ref, onLayout } = useViewDimensions('LEVEL_HEADER_ITEM');

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleClick = () => {
    BottomSheet.open({
      namespace: 'levels',
      type: 'levelProgressInfo',
      titleNS: 'levels',
      titleKey: 'levelUpWithBonanza',
      scrollable: true,
      contentPaddingHorizontal: 'space-0',
      onInfo: () => navigation.navigate('MiscScreen', { path: '/level-up' }),
    });
  };
  const { loyalty, points } = useLoyalty();
  const prevLevel = useRef(loyalty?.level);

  const { tooltipVisible, showTooltip, hideTooltip } = useHeaderTooltip();

  useEffect(() => {
    if (loyalty?.level !== prevLevel.current) {
      if (prevLevel.current) {
        showTooltip();
      }
      prevLevel.current = loyalty?.level;
    }
  }, [loyalty?.level, showTooltip]);

  return (
    <Pressable
      testID="level-header-item"
      ref={ref}
      style={pressableStyle}
      onLayout={onLayout}
      onPress={handleClick}
    >
      {loyalty ? (
        <Box gap="space-100">
          <Text variant="nav-label" color={'darkSurfacePrimary'}>
            {t('level')} {loyalty.level}
          </Text>

          <ProgressBar
            level={loyalty.level}
            from={loyalty.startPoints}
            to={loyalty.endPoints}
            progress={points}
          />
        </Box>
      ) : null}
      <HeaderTooltip
        visible={tooltipVisible}
        hide={hideTooltip}
        locNS="levels"
        locKey="levelUp"
      />
    </Pressable>
  );
}

export default memo(Levels);
